import NoImg from "../assets/no_img.svg";

const itemImageStyle = (imageName) => {
  if (!imageName) {
    return { backgroundImage: `url(${NoImg})` };
  }
  const base = process.env.BACKEND_URL?.replace("/api", "") || "";
  return {
    backgroundImage: `url(${base}/public/images/${imageName}), url(${NoImg})`,
    backgroundSize: "cover, cover",
  };
};

export default itemImageStyle;
